import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useUrlStep = <T extends string>(
  getValidStep: (rawStep: string | null) => T,
) => {
  const { search, pathname } = useLocation();
  const history = useHistory();

  const params = new URLSearchParams(search);
  const rawStepFromParams = params.get('step');

  const setStep = (step: T) => {
    const params = new URLSearchParams(search);
    params.set('step', step);

    history.replace(`${pathname}?${params.toString()}`);
  };

  const validStepFromParams = getValidStep(rawStepFromParams);

  useEffect(() => {
    if (rawStepFromParams !== validStepFromParams) {
      setStep(validStepFromParams);
    }
  }, [validStepFromParams]);

  return {
    step: validStepFromParams,
    setStep,
  };
};

export default useUrlStep;
